import GenericAPI, { CONTENT_TYPE } from "../GenericApi";
class BuyerPaymentApi extends GenericAPI {

    BUYER_PAYMENT_STATUS_OR_REQUEST_ENDPOINT="/api/paymentRequest/paymentRequestBuyer"

    async getBuyerPaymentStatus(buyerId) {
        const isPaid = true
        const payload =  {
            buyerId,
            isPaid
        }
        return this.get(this.BUYER_PAYMENT_STATUS_OR_REQUEST_ENDPOINT, payload, CONTENT_TYPE.URLENCODED, true);
    }

    async getBuyerPaymentRequest(buyerId) {
        const isPaid = false
        const payload =  {
            buyerId,
            isPaid
        }
        return this.get(this.BUYER_PAYMENT_STATUS_OR_REQUEST_ENDPOINT, payload, CONTENT_TYPE.URLENCODED, true);
    }

}

export default new BuyerPaymentApi();